import { axios2 } from '@/lib/axios';
import { useQuery } from 'react-query';

export const getFinalizeListing = async () => {
  return axios2.get('/lawyer-api/listing-finalize-lawyer');
};

export const useGetFinalizeListing = () => {
  return useQuery({
    queryKey: ['finalize-lawyer-listing-lawyer-side'],
    queryFn: getFinalizeListing,
  });
};
